import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgProgressModule } from 'ngx-progressbar';
import { SearchFilterSortModule, SearchFilterSortService } from 'ng-searchfiltersort';

import { MainRoutingModule } from './main-routing.module';
import {
  DxMenuModule,
  DxBoxModule,
  DxResponsiveBoxModule,
  DxSelectBoxModule,
  DxTreeViewModule,
  DxCheckBoxModule,
  DxTemplateModule,
  DxButtonModule,
  DxDataGridModule,
  DxContextMenuModule,
  DxPopupModule,
  DxTextBoxModule,
  DxDateBoxModule,
  DxListModule,
  DxScrollViewModule,
  DxProgressBarModule,
  DxLoadPanelModule
} from 'devextreme-angular';
import { ConfigurationStoreService } from './services/configuration-store/configuration-store.service';
import { CustomService } from './services/custom/custom.service';
import { FunctionService } from './services/function/function.service';
import { NotificationService } from './services/notification/notification.service';
import { SessionStoreService } from './services/session-store/session-store.service';
import { LookAndFillStoreService } from './services/look-and-fill-store/look-and-fill-store.service';
import { DictionaryStoreService } from './services/dictionary-store/dictionary-store.service';
import { DialogControllerService } from './services/dialog-controller/dialog-controller.service';
import { DialogDataStoreService } from './services/dialog-data-store/dialog-data-store.service';
import { FileSelectionStoreService } from './services/file-selection-store/file-selection-store.service';
import { ResourceStoreService } from './services/resource-store/resource-store.service';
import { UserProfileService } from './services/user-profile/user-profile.service';
import { ProfileStoreService } from './services/profile-store/profile-store.service';
import { FunctionStoreService } from './services/function-store/function-store.service';
import { ActiveViewStoreService } from './services/active-view-store/active-view-store.service';
import { ViewSelectorService } from './services/view-selector/view-selector.service';
import { DocumentSigningService } from './services/document-signing/document-signing.service';
import { UploadService } from './services/upload/upload.service';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import * as components from './components';
import { ViewContainerComponent } from './components/view-container/view-container.component';
import { FooterComponent } from './components/footer/footer.component';
import { StatusBarComponent } from './components/status-bar/status-bar.component';
import { UserProfileViewComponent } from './components/user-profile-view/user-profile-view.component';
import { DialogsComponent } from './components/dialogs/dialogs.component';
import { LoadingComponent } from './components/loading/loading.component';
import { FileSelectionComponent } from './components/file-selection/file-selection.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { UploadViewComponent } from './components/upload-view/upload-view.component';
import { ReceiverSelectorComponent } from './components/receiver-selector/receiver-selector.component';
import { StartupComponent } from './components/startup/startup.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LoadingControllerService } from './services/loading-controller/loading-controller.service';

@NgModule({
  declarations: [
    SafeUrlPipe,
    SafeHtmlPipe,
    components.AdminComponent,
    components.HeaderComponent,
    components.HomeComponent,
    components.TopMenuComponent,
    components.NavMenuComponent,
    components.SideMenuComponent,
    components.DataViewHeaderComponent,
    components.DataViewGridComponent,
    components.ContextMenuComponent,
    components.SingleViewComponent,
    components.FileSelectionComponent,
    components.MainViewComponent,
    components.ErrorViewComponent,
    components.ProfileViewComponent,
    components.SingleViewCustomComponent,
    components.SingleViewCustomActionComponent,
    components.CertViewComponent,
    components.AboutViewComponent,
    ViewContainerComponent,
    FooterComponent,
    StatusBarComponent,
    UserProfileViewComponent,
    DialogsComponent,
    LoadingComponent,
    FileSelectionComponent,
    ProgressBarComponent,
    UploadViewComponent,
    ReceiverSelectorComponent,
    StartupComponent,
    LayoutComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MainRoutingModule,
    DxMenuModule,
    DxContextMenuModule,
    DxPopupModule,
    DxBoxModule,
    DxTextBoxModule,
    DxDateBoxModule,
    DxButtonModule,
    DxResponsiveBoxModule,
    DxListModule,
    DxSelectBoxModule,
    DxDataGridModule,
    DxTreeViewModule,
    DxScrollViewModule,
    DxCheckBoxModule,
    DxProgressBarModule,
    DxTemplateModule,
    NgProgressModule,
    DxLoadPanelModule,
    SearchFilterSortModule.forRoot()
  ],
  providers: [
    NotificationService,
    DialogControllerService,
    LoadingControllerService,
    DialogDataStoreService,
    FileSelectionStoreService,
    FunctionService,
    SessionStoreService,
    ResourceStoreService,
    UserProfileService,
    ProfileStoreService,
    ConfigurationStoreService,
    LookAndFillStoreService,
    DictionaryStoreService,
    FunctionStoreService,
    ActiveViewStoreService,
    ViewSelectorService,
    CustomService,
    SearchFilterSortService,
    DocumentSigningService,
    UploadService
  ],
  entryComponents: [],

  // purpose of these exports is that dynamically created modules/components might need to re-use this module's components
  // exports:[
  //     componentList
  // ]
  exports: [
    SafeUrlPipe,
    components.AdminComponent,
    components.HeaderComponent,
    components.HomeComponent,
    components.TopMenuComponent,
    components.NavMenuComponent,
    components.SideMenuComponent,
    components.DataViewHeaderComponent,
    components.DataViewGridComponent,
    components.ContextMenuComponent,
    components.SingleViewComponent,
    components.FileSelectionComponent,
    components.MainViewComponent,
    components.ErrorViewComponent,
    components.ProfileViewComponent,
    components.SingleViewCustomComponent,
    components.SingleViewCustomActionComponent,
    components.CertViewComponent,
    components.AboutViewComponent
  ]
})
export class MainModule {}



// WEBPACK FOOTER //
// ./src/app/main.module.ts